export enum FamilyResidentSettings {
  ResidentConsent = 'residentConsent',
}